import { required, email, sameAs, minLength, maxLength,
  requiredIf, minValue, maxValue, numeric } from 'vuelidate/lib/validators'

export const setNewPassword = {
  body: {
    password: {
      required,
      minLength: minLength(8),
      maxLength: maxLength(20)
    },
    repeatPassword: {
      required,
      sameAs: sameAs('password'),
    },
  },
}

export const finishRegistration = {
  body: {
    new_password: {
      required,
      minLength: minLength(6),
      maxLength: maxLength(20)
    },
    new_password_confirmation: {
      required,
      sameAs: sameAs('new_password')
    }
  }
}

export const authForm = context => ({
  body: {
    login: {
      required,
      email: context.loginFormat === 'email',
    },
    password: { required }
  }
})

export const registrationForm = context => ({
  body: {
    phone: {
      required,
      minLength: minLength(10),
      maxLength: maxLength(16)
    },
    email: {
      required: requiredIf(() => !context.isInviteRegistration),
      email,
      minLength: minLength(2),
      maxLength: maxLength(50)
    },
    first_name: {
      required,
      minLength: minLength(2),
      maxLength: maxLength(15)
    },
    last_name: {
      required,
      minLength: minLength(2),
      maxLength: maxLength(15)
    },
    middle_name: {
      minLength: minLength(2),
      maxLength: maxLength(15)
    },
    password: {
      required,
      minLength: minLength(6),
      maxLength: maxLength(20)
    },
    repeatPass: {
      required,
      sameAs: sameAs('password')
    },
    name: {
      required: requiredIf(() => !context.isInviteRegistration),
      minLength: minLength(2),
      maxLength: maxLength(100)
    },
    agreement: {
      checked (value) { return value }
    }
  }
})

export const createdUserForm = {
  body: {
    first_name: { required },
    last_name: { required },
    middle_name: { required },
    email: { required, email },
    spaces: { required },
    company: { required },
    accountType: { required },
    // phone: {
    //   required,
    //   minLength: minLength(10),
    //   maxLength: maxLength(16)
    // },
  },
}

export const editUserForm = context => ({
  currentBody: {
    first_name: { required },
    last_name: { required },
    email: { required, email },
    spaces: { required: requiredIf(() => context.isUserCreateForm) },
    user_types: { required },
    language: { required },
    phone: {
      required,
      minLength: minLength(10),
      maxLength: maxLength(16)
    }
  },
  changePassword: {
    old_password: {
      required: requiredIf(() => context.changePassword.new_password || context.changePassword.new_password_confirm)
    },
    new_password: {
      required: requiredIf(() => context.changePassword.old_password || context.changePassword.new_password_confirm)
    },
    new_password_confirm: {
      required: requiredIf(() => context.changePassword.old_password || context.changePassword.new_password),
      sameAs: sameAs('new_password')
    }
  }
})

export const companyForm = {
  body: {
    name: { required },
    company_email: { required, email },
    company_phone: {
      required,
      minLength: minLength(10),
      maxLength: maxLength(16)
    },
    description: { maxLength: maxLength(500) },
    owner: { required }
  }
}

export const createdGroupForm = {
  body: {
    description: { minLength: minLength(10), maxLength: maxLength(250) },
    name: { required, minLength: minLength(3), maxLength: maxLength(150) }
  }
}

export const createCourseForm = {
  body: {
    name: { required, minLength: minLength(5), maxLength: maxLength(50) },
    description: { required, minLength: minLength(0), maxLength: maxLength(512) },
    material_access_terms: { required }
  }
}

export const createProgramForm = {
  body: {
    name: { required, minLength: minLength(5), maxLength: maxLength(50) },
    description: { required, minLength: minLength(0), maxLength: maxLength(512) },
    material_access_terms: { required }
  }
}

export const forgotPass = {
  body: {
    email: { required, email }
  }
}

export const educationMaterialsForm = () => ({
  body: {
    name: {
      required,
      maxLength: maxLength(255),
      minLength: minLength(0)
    },
    description: { required }
  }
})

export const constructorSettings = context => {
  return {
    selectedForm: {
      passing_score_type: { required },
      name: { required },
      time_limit: { numeric },
      form_type: { required },
      passing_score: {
        required: requiredIf(() => context.selectedForm.passing_score_type === 1),
        minValue: minValue(0),
        maxValue: context.selectedForm.passing_score_type === 1 ? maxValue(context.totalScoreNumber) : true
      }
    }
  }
}

export const inviteUserForm = context => ({
  body: {
    user_types: {
      required: requiredIf(() => context.$route.name === 'group-edit')
    }
  }
})
